import { getAmplitudeInstance } from '../amplitudeHelpers';

/**
 * User views the contextual edit menu. note: if the user takes an action from this menu, it will fire the custom route updated event
 */
const logCustomRouteContextualEditMenuViewed = (callback?: () => void) => {
  getAmplitudeInstance().logEvent('custom route contextual edit menu viewed', {}, callback);
};

export default logCustomRouteContextualEditMenuViewed;
